const ShieldGoodIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        d="M12.4651 15.3327L15.1318 17.9994L20.6667 12.4644M15.6338 4.10404L7.63379 6.38975C7.06138 6.55329 6.66675 7.07647 6.66675 7.67178L6.66675 14.4711C6.66675 18.7772 8.74629 22.8181 12.2502 25.3209L15.2251 27.4458C15.6887 27.777 16.3115 27.777 16.7751 27.4458L19.7499 25.3209C23.2539 22.8181 25.3334 18.7772 25.3334 14.4711V7.67178C25.3334 7.07647 24.9388 6.55329 24.3664 6.38975L16.3664 4.10404C16.127 4.03563 15.8732 4.03563 15.6338 4.10404Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default ShieldGoodIcon;
